export const tripImageStyle = {
    width: '100%',
};

export const textStyle = {
    color: 'white',
    paddingTop: '10px',
    fontSize: '18px',
    letterSpacing: '0.1rem',
};

export const sectionStyle = {
    position: 'relative',
    p: '20px',
    pt: '100px',
    pb: '80px',
    mx: "auto",
    width: "100%",
    minHeight: '60vh',
    backgroundColor: '#ffffff',
    alignContent: 'center',
};

export const gridContainer = {
    flexDirection: {
        xs: "column",
        sm: "row"
    },
};

export const contentGridContainerStyle = {
    display: {
        xs: "none", // Hide on xs screens
        sm: "flex", // Show on sm and larger screens
    },
    alignContent: 'center',
    justifyContent: "center",
};

export const textGridStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
};

export const titleStyle = {
    fontWeight: 'bold',
    color: 'white',
    textAlign: 'center',
    fontFamily: 'Merriweather',
    paddingBottom: '10px'
};
